import React, { memo, useState, useEffect, useCallback } from 'react';
// import PropTypes from 'prop-types';
import { Form, Skeleton, Button } from 'antd';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import Actions from '@flux/action';
import {
  QUES_SECTIONS_SEQ,
  QUES_SECTIONS_KEYS,
} from '@model/questionmaires/questionnaire';

import Header from './sections/sectionHeader';
import {
  Strategy,
  People,
  // Value,
  // Execution,
  Enterprise,
  Overall,
} from './sections';

// import '@style/modules/questionnaires/complexity.scss';
// import '@style/modules/questionnaires/complexity-narrow.scss';
import '../../../styles/modules/questionnaires/complexity.scss';
import '../../../styles/modules/questionnaires/complexity-narrow.scss';
import { deepCopy } from '@utils/common';
import Content from './sections/content';

export const SECTIONS = {
  [QUES_SECTIONS_KEYS.StrategyValue]: Strategy,
  // value: Value,
  [QUES_SECTIONS_KEYS.EnterpriseIntegrationConsiderations]: Enterprise,
  [QUES_SECTIONS_KEYS.OrganizationPeople]: People,
  // execution: Execution,
};

// Generate Header Map to keep compatibility
export const HEADER = ['overall', ...QUES_SECTIONS_SEQ].reduce(
  (acc, e) => ({
    ...acc,
    [e]: `${e} complexity`,
  }),
  {},
);

function ComplexityPortal({
  handleLeftExpand,
  handleRightExpand,
  isLeftExpand,
  isRightExpand,
  fetchData,
  submitData,
  isFetchLoading,
  isActionLoading,
  data = {},
  lastEditAt,
  lastEditBy,
  changeQuestions,
  submitRiskData,
  isRiskLoading,
  complexitySiderData,
  currentMode,
  toggleCurrentMode,
  fetchComplexityMode,
  postComplexityMode,
  modelsData,
  changeSideBarLevel,
  cancelQuestionEdit,
}) {
  const { params: { currentSection } = { currentSection: 'overall' } } =
    useRouteMatch('/questionnaires/complexity/:currentSection') || {};

  const [isEditing, setIsEditing] = useState(false);
  const [canSave, setCanSave] = useState(true);

  const [form] = Form.useForm();

  const submit = async () => {
    await submitData({
      section: currentSection,
      formData: form.getFieldsValue(true),
    });
    setIsEditing(false);

    if (currentSection !== 'overall') {
      form.resetFields();
    }
  };

  const handleSubmit = () => {
    submit();
    if (currentSection !== 'overall') {
      handleRiskSave();
    }
  };
  const changeSaveButton = (e) => {
    setCanSave(e);
  };

  const handleRiskSave = async () => {
    await submitRiskData({
      section: currentSection,
      formData: form.getFieldsValue(true),
    });
  };

  const handleGaugeValueChange = useCallback(
    (gaugeValue) => {
      changeSideBarLevel(currentSection, gaugeValue);
    },
    [currentSection],
  );

  const getSectionReport = (section) => {
    const sectionIndex =
      QUES_SECTIONS_SEQ.findIndex((itm, idx) => itm === section) + 1;
    const Comp = SECTIONS[section] || Overall;
    return (
      <Comp
        handleEdit={handleEdit}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        handleGaugeValueChange={handleGaugeValueChange}
        isRiskEditng={isEditing}
        form={form}
        isLoading={isActionLoading}
        isRiskLoading={isRiskLoading}
        isEditing={isEditing}
        selectMode={currentMode !== 'auto' && isEditing}
        currentMode={currentMode}
        formInstance={form}
        changeSaveButton={changeSaveButton}
        data={!data.sectionNum || data.sectionNum === sectionIndex ? data : {}}
        modelsData={modelsData}
        c={Content}
      />
    );
    // return null;
  };

  const initializeState = () => {
    setIsEditing(false);
  };

  const handleEdit = () => {
    if (isEditing) {
      return handleCancel();
    }
    setIsEditing(true);
    restField();
  };

  const restField = () => {
    form.resetFields();
  };

  const handleCancel = () => {
    setIsEditing(false);
    setCanSave(true);
    const newData = deepCopy(data);
    changeQuestions({ complexityData: newData });
    cancelQuestionEdit();
  };

  const handleModeChange = (e) => {
    const isManual = e === 'manual';
    postComplexityMode({
      projectStatusInfo: {
        complexityOutputManualViewFlag: isManual,
      },
    });
    toggleCurrentMode(e);
    fetchData(currentSection, isManual);
  };

  useEffect(() => {
    currentSection && fetchData(currentSection);

    fetchComplexityMode();
    initializeState();
  }, [currentSection]);

  return (
    <div className={`questionnaires-complexity-content ${currentSection}`}>
      <Skeleton active loading={isFetchLoading} paragraph={{ rows: 10 }}>
        <Header
          currentSection={currentSection}
          isLoading={isActionLoading}
          section={currentSection}
          title={HEADER[currentSection]}
          lastEditAt={lastEditAt}
          lastEditBy={lastEditBy}
          isEditing={isEditing}
          onEdit={handleEdit}
          onSave={handleSubmit}
          handleLeftExpand={() => handleLeftExpand((s) => !s)}
          handleRightExpand={() => handleRightExpand((s) => !s)}
          isRightExpand={isRightExpand}
          canSave={canSave}
          changeMode={handleModeChange}
          currentMode={currentMode}
        />
        <Form form={form} preserve>
          {getSectionReport(currentSection)}
        </Form>
        <PreviousOrNextBtn
          currentSection={currentSection}
          complexitySiderData={complexitySiderData}
        />
      </Skeleton>
    </div>
  );
}

const PreviousOrNextBtn = memo(
  ({
    currentSection,
    complexitySiderData: { abled, clickableSectionPaths },
  }) => {
    const history = useHistory(),
      path = clickableSectionPaths?.filter((p) => p),
      currentIndex = path?.findIndex((p) => p === `/${currentSection}`);
    if (!abled || currentIndex < 0) {
      return null;
    }
    return (
      <div className="pre-next-btn-box">
        {currentIndex !== 0 ? (
          <Button
            className="btn pre-btn"
            onClick={() => {
              history.push(
                `/questionnaires/complexity${path[currentIndex - 1]}`,
              );
            }}
          >
            previous
          </Button>
        ) : (
          <span />
        )}
        {currentIndex !== path.length - 1 ? (
          <Button
            type="primary"
            className="btn"
            onClick={() => {
              history.push(
                `/questionnaires/complexity${path[currentIndex + 1]}`,
              );
            }}
          >
            next
          </Button>
        ) : (
          <span />
        )}
      </div>
    );
  },
);

ComplexityPortal.propTypes = {};

const mapDispatchToProps = (dispatch) => ({
  fetchData(section, isManual) {
    dispatch(Actions.fetchComplexityBySection(section, isManual));
  },
  fetchComplexityMode() {
    dispatch(Actions.fetchComplexityMode());
  },
  postComplexityMode(p) {
    dispatch(Actions.postComplexityMode(p));
  },
  submitData(data) {
    return dispatch(Actions.saveComplexityBySection(data));
  },
  submitRiskData(data) {
    return dispatch(Actions.saveRiskBySection(data));
  },
  changeQuestions(data) {
    dispatch(Actions.changeQuestions(data));
  },
  toggleCurrentMode(mode) {
    dispatch(Actions.changeComplexityMode(mode));
  },
  changeSideBarLevel(section, levelPercent) {
    dispatch(Actions.changeSidebarSectionLevel({ section, levelPercent }));
  },
  cancelQuestionEdit() {
    dispatch(Actions.cancelQuestionEdit());
  },
});
const mapStateToProps = ({ question }) => ({
  isFetchLoading: question.isFetchLoading,
  isActionLoading: question.isActionLoading,
  isRiskLoading: question.isRiskLoading,
  data: question.complexityData,
  modelsData: question.modelsData,
  lastEditAt: question.lastEditAt,
  lastEditBy: question.lastEditBy,
  complexitySiderData: question.complexitySiderData || {
    clickableSectionPaths: [],
  },
  currentMode: question.currentComplexityMode,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ComplexityPortal));
